// Router.jsx
import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import AboutUs from '../page/AboutUs/AboutUs';
import Home from '../page/home/Home';
import Services from '../page/servicesPage/Services';
import Skill from '../page/skill/Skill';
import Navbar from '../component/navbar/Navbar';
import Portfolio from '../page/portfolio/Portfolio';
import Contact from '../page/contact/Contact';
import Admin from '../page/Admin/Admin';
import AdminLogin from '../page/Admin/AdminLogin';
import ProtectedRoute from '../component/ProtectedRoute';

// Create the browser router with routes
const router = createBrowserRouter([
    {
        path: "/",
        element: <><Navbar /><Home /></>,
    },
    {
        path: "/aboutus",
        element: <><Navbar /><AboutUs /></>,
    },
    {
        path: "/services",
        element: <><Navbar /><Services /></>,
    },
    {
        path: "/skill",
        element: <><Navbar /><Skill /></>,
    },
    {
        path: "/portfolio",
        element: <><Navbar /><Portfolio /></>,
    },
    {
        path: "/contact",
        element: <><Navbar /><Contact /></>,
    },
    {
        path: "/admin-login",
        element: <AdminLogin />,
    },
    {
        path: "/admin",
        element: (
            <ProtectedRoute>
                <Admin />
            </ProtectedRoute>
        ),
    },
]);

const App = () => {
    return (
        <RouterProvider router={router} />  
    );
};

export default App;
